import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.5 22.08"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.44 9.42c-.03-.07-.08-.13-.13-.2 0-.02-.02-.04-.04-.06l-2.19-2.19c-.29-.29-.84-.29-1.13 0a.796.796 0 0 0-.01 1.13l.83.83h-4.66c-.44 0-.8.36-.8.8s.36.8.8.8h4.66l-.83.83a.81.81 0 0 0-.01 1.14c.15.15.35.23.56.23s.41-.08.57-.23l2.2-2.2s.06-.07.07-.1l.04-.06s.04-.06.06-.1c.04-.09.06-.19.06-.29v-.03c0-.1-.02-.2-.06-.29Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.31 14.27c-.52 0-.95.43-.95.95v1.1c0 .69-.56 1.25-1.25 1.25h-3.44V5.89c0-.97-.49-1.92-1.34-2.61l-.09-.06L7.13 1.9h6.99c.69 0 1.25.56 1.25 1.25v1.1c0 .52.43.95.95.95s.95-.43.95-.95v-1.1c0-1.73-1.41-3.14-3.14-3.14H3.14s-.05 0-.06.01C1.59.05 0 1.16 0 3.14V16.2c0 .97.49 1.92 1.34 2.6.03.02.06.04.09.07l4.39 2.74.03.02a3.268 3.268 0 0 0 3.13.1c.9-.46 1.5-1.28 1.65-2.28h3.48c1.73 0 3.14-1.41 3.14-3.14v-1.1a.95.95 0 0 0-.95-.95Zm-7.53 4.68c0 .45-.23.85-.61 1.08-.41.24-.91.23-1.36-.02l-4.32-2.7c-.38-.32-.6-.72-.6-1.1V3.14c0-.34.13-.65.36-.88s.55-.36.89-.36c.24 0 .48.07.71.19l4.32 2.7c.38.32.6.72.6 1.1v13.06Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }